import Vue from 'vue'
import {helpers} from "../../helpers";

export default {
    store: {
        namespaced: true,
        state: {
            endpoint: 'companies',
            companies: [],
            companies_amount: 0,
            company: {}
        },
        actions: {
            //Получение списка компаний
            getCompanies({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/company', {params: data}).then(r => {
                    if (!r || !r.data) return null;
                    Vue.set(state, 'companies', r.data || r);
                    Vue.set(state, 'companies_amount', r.total);
                    return r;
                });
            },

            //Получение компании
            getCompany({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/company/byid/' + data.id, data).then(r => {
                    Vue.set(state, 'company', r);
                    return r;
                });
            },

            //Изменение компании
            putCompany({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/company', data);
            },

            //Добавление компании
            postCompany({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/company', data);
            },

            //Удаление компании
            removeCompany({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/company/byid/' + id);
            },

            //Прикрепление адреса к компании
            attachAddress({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/company/addresses/attach', data);
            },

            //Открепление адреса от компании
            detachAddress({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/company/addresses/detach', data);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/companies/store.js